/**
 * @file Automatically generated by barrelsby.
 */

export * from './info-field.component';
export * from './info-field.module';
